import React, { useState, useEffect, useRef } from 'react';
import './Pages.css';

function AboutUs() {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const currentRefs = sectionRefs.current.filter(ref => ref !== null);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );

    currentRefs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
      observer.disconnect();
    };
  }, []);


  useEffect (() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('Ad showing...');
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }, []);


  const values = [
    {
      icon: '🌏',
      title: 'Global Connection',
      description: 'Bringing Tamil communities together from every corner of the world'
    },
    {
      icon: '👨‍👩‍👧‍👦',
      title: 'Generational Unity',
      description: 'Creating experiences that resonate across all ages'
    },
    {
      icon: '🎮',
      title: 'Innovation',
      description: 'Blending tradition with cutting-edge technology'
    },
    {
      icon: '❤️',
      title: 'Cultural Pride',
      description: 'Celebrating and preserving Tamil heritage for future generations'
    },
    {
      icon: '🌏',
      title: 'Global Connection',
      description: 'Bringing Tamil communities together from every corner of the world'
    },
    {
      icon: '👨‍👩‍👧‍👦',
      title: 'Generational Unity',
      description: 'Creating experiences that resonate across all ages'
    }
  ];

  return (
    <div className="page-container">
      <div className="about-us-container">
        {/* Hero Section - Fixed at Top */}
        <section className="about-hero fixed-hero">
          <h1>About Ulaga Tamizhar</h1>
          <p className="about-tagline">Bringing Generations Together Through Play</p>
        </section>

        {/* Spacer for fixed hero */}
        <div className="hero-spacer"></div>

        {/* Mission Section */}
        <section 
          className="about-card fade-in"
          ref={(el) => (sectionRefs.current[0] = el)}
        >
          <div className="about-card-content">
            <h2>Who We Are</h2>
            <p>
              We are a tech company on a mission to unite Tamil communities across the globe. 
              Through innovative mobile games and digital experiences, we're creating bridges 
              between generations, helping families stay connected to their culture and to each other.
            </p>
          </div>
        </section>

        {/* What We Do Section */}
        <section 
          className="about-card fade-in"
          ref={(el) => (sectionRefs.current[1] = el)}
        >
          <div className="about-card-content">
            <h2>What We Do</h2>
            <p>
              Right now, we're building engaging mobile games that celebrate Tamil language and 
              culture. Our games are designed to be enjoyed by everyone—from grandparents to 
              grandchildren—creating shared moments of laughter and connection no matter where 
              in the world they are.
            </p>
          </div>
        </section>

        {/* Vision Section */}
        <section 
          className="about-card fade-in"
          ref={(el) => (sectionRefs.current[2] = el)}
        >
          <div className="about-card-content">
            <h2>Our Vision</h2>
            <p>
              While mobile games are where we're starting, our ambitions reach far beyond. 
              We envision a future filled with innovative products and experiences that keep 
              Tamil heritage alive and thriving in the digital age. We're building the foundation 
              today for something much bigger tomorrow.
            </p>
          </div>
        </section>

        {/* Values Section - Horizontal Scrolling */}
        <section className="about-values">
          <h2>What Drives Us</h2>
          <div className="values-scroll-container">
            <div className="values-scroll">
              {values.map((value, index) => (
                <div className="value-card-scroll" key={index}>
                  <div className="value-icon">{value.icon}</div>
                  <h3>{value.title}</h3>
                  <p>{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="about-cta">
          <h2>Join Our Journey</h2>
          <p>
            We're just getting started, and we'd love for you to be part of our story. 
            Download our games, share them with your family, and help us grow a global 
            Tamil community connected through play.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutUs;
